import { render, staticRenderFns } from "./InscriptionDeleteModal.vue?vue&type=template&id=2edef02f&scoped=true&"
import script from "./InscriptionDeleteModal.vue?vue&type=script&lang=js&"
export * from "./InscriptionDeleteModal.vue?vue&type=script&lang=js&"
import style0 from "./InscriptionDeleteModal.vue?vue&type=style&index=0&id=2edef02f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edef02f",
  null
  
)

export default component.exports